export default "__VITE_PUBLIC_ASSET__3d979108__"